const Email = () => require('@/assets/images/icons/email.svg')
const Lock = () => require('@/assets/images/icons/lock.svg')
const Eye = () => require('@/assets/images/icons/eye.svg')
const Baby = () => require('@/assets/images/icons/baby.svg')
const Calendar = () => require('@/assets/images/icons/calendar.svg')
const ArrowLeft = () => require('@/assets/images/icons/arrow-left.svg')
const Delete = () => require('@/assets/images/icons/delete.svg')
const Menu = () => require('@/assets/images/icons/menu.svg')
const Up = () => require('@/assets/images/icons/up.svg')
const Down = () => require('@/assets/images/icons/down.svg')
const MediaVideo = () => require('@/assets/images/icons/media-video.svg')
const MediaSalon = () => require('@/assets/images/icons/media-salon.svg')
const MediaWeb = () => require('@/assets/images/icons/media-web.svg')
const MediaLive = () => require('@/assets/images/icons/media-live.svg')
const ChevronDownSmall = () => require('@/assets/images/icons/chevron-down-small.svg')
const ChevronUpSmall = () => require('@/assets/images/icons/chevron-up-small.svg')
const Verified = () => require('@/assets/images/icons/verified.svg')
const OptionDel = () => require('@/assets/images/icons/option-del.svg')
const BarAlbum = () => require('@/assets/images/icons/bar_album.svg')
const DeleteRed = () => require('@/assets/images/icons/delete_red.svg')
const FHome = () => require('@/assets/images/icons/f-home.svg')
const FGrowTree = () => require('@/assets/images/icons/f-grow-tree.svg')
const FAlbum = () => require('@/assets/images/icons/f-album.svg')
const FSearch = () => require('@/assets/images/icons/f-search.svg')
const FSearchGreen = () => require('@/assets/images/icons/f-search-green.svg')
const FAlbumGreen = () => require('@/assets/images/icons/f-album-green.svg')
const FHomeGreen = () => require('@/assets/images/icons/f-home-green.svg')
const FGrowTreeGreen = () => require('@/assets/images/icons/f-grow-tree-green.svg')
const BackIcon = () => require('@/assets/images/icons/back-icon.svg')
const SideBar = () => require('@/assets/images/icons/side-bar.svg')
const LogoutIcon = () => require('@/assets/images/icons/logout.svg')
const BackPrimary = () => require('@/assets/images/icons/back-primary.svg')
const Close = () => require('@/assets/images/icons/close.svg')
const Video = () => require('@/assets/images/icons/video.svg')
const BabyGreen = () => require('@/assets/images/icons/baby-green.svg')
const BabyG = () => require('@/assets/images/icons/baby-g.svg')
const Live = () => require('@/assets/images/icons/live.svg')
const Event = () => require('@/assets/images/icons/event.svg')
const Salon = () => require('@/assets/images/icons/salon.svg')
const Setting = () => require('@/assets/images/icons/setting.svg')
const EyeActive = () => require('@/assets/images/icons/eye-active.svg')

const Icons = [
  {
    src: Email,
    width: 24,
    height: 24,
    name: 'email'
  },
  {
    src: Lock,
    width: 16,
    height: 17,
    name: 'lock'
  },
  {
    src: Eye,
    width: 24,
    height: 24,
    name: 'eye'
  },
  {
    src: Baby,
    width: 24,
    height: 24,
    name: 'baby'
  },
  {
    src: Calendar,
    width: 24,
    height: 24,
    name: 'calendar'
  },
  {
    src: ArrowLeft,
    width: 16,
    height: 12,
    name: 'arrowLeft'
  },
  {
    src: Delete,
    width: 24,
    height: 24,
    name: 'delete'
  },
  {
    src: Menu,
    width: 24,
    height: 24,
    name: 'menu'
  },
  {
    src: Up,
    width: 16,
    height: 9,
    name: 'up'
  },
  {
    src: Down,
    width: 16,
    height: 9,
    name: 'down'
  },
  {
    src: MediaVideo,
    width: 30,
    height: 30,
    name: 'media-video'
  },
  {
    src: MediaSalon,
    width: 30,
    height: 30,
    name: 'media-salon'
  },
  {
    src: MediaWeb,
    width: 30,
    height: 30,
    name: 'media-web'
  },
  {
    src: MediaLive,
    width: 30,
    height: 30,
    name: 'media-live'
  },
  {
    src: ChevronDownSmall,
    width: 24,
    height: 24,
    name: 'chevron-down-small'
  },
  {
    src: ChevronUpSmall,
    width: 24,
    height: 24,
    name: 'chevron-up-small'
  },
  {
    src: Verified,
    width: 20,
    height: 20,
    name: 'verified'
  },
  {
    src: OptionDel,
    width: 32,
    height: 32,
    name: 'optionDel'
  },
  {
    src: BarAlbum,
    width: 28,
    height: 28,
    name: 'bar-album'
  },
  {
    src: DeleteRed,
    width: 28,
    height: 28,
    name: 'delete-red'
  },
  {
    src: FHome,
    width: 28,
    height: 28,
    name: 'fHome'
  },
  {
    src: FGrowTree,
    width: 28,
    height: 28,
    name: 'fGrowTree'
  },
  {
    src: FAlbum,
    width: 28,
    height: 28,
    name: 'fAlbum'
  },
  {
    src: FSearch,
    width: 28,
    height: 28,
    name: 'fSearch'
  },
  {
    src: FSearchGreen,
    width: 28,
    height: 28,
    name: 'fSearchGreen'
  },
  {
    src: FAlbumGreen,
    width: 28,
    height: 28,
    name: 'fAlbumGreen'
  },
  {
    src: FHomeGreen,
    width: 28,
    height: 28,
    name: 'fHomeGreen'
  },
  {
    src: FGrowTreeGreen,
    width: 28,
    height: 28,
    name: 'fGrowTreeGreen'
  },
  {
    src: BackIcon,
    width: 32,
    height: 32,
    name: 'backIcon'
  },
  {
    src: SideBar,
    width: 40,
    height: 40,
    name: 'sideBar'
  },
  {
    src: LogoutIcon,
    width: 40,
    height: 40,
    name: 'logoutIcon'
  },
  {
    src: BackPrimary,
    width: 32,
    height: 32,
    name: 'backPrimary'
  },

  {
    src: Close,
    width: 12,
    height: 12,
    name: 'close'
  },
  {
    src: Video,
    width: 32,
    height: 32,
    name: 'video'
  },
  {
    src: BabyGreen,
    width: 32,
    height: 32,
    name: 'baby-green'
  },
  {
    src: BabyG,
    width: 28,
    height: 28,
    name: 'baby-g'
  },
  {
    src: Live,
    width: 32,
    height: 32,
    name: 'live'
  },
  {
    src: Event,
    width: 32,
    height: 32,
    name: 'event'
  },
  {
    src: Salon,
    width: 32,
    height: 32,
    name: 'salon'
  },
  {
    src: Setting,
    width: 32,
    height: 32,
    name: 'setting'
  },
  {
    src: EyeActive,
    width: 24,
    height: 24,
    name: 'eyeActive'
  },
]

export default Icons
